<div class="course-description-card">
  <!-- Description Header -->
  <div class="course-description-card__header">
    <div class="course-description-card__header-container">
      <div class="course-description-card__header-title">
        <div class="course-description-card__header-title-text">
          {{ 'app.components.courseCreator.publish.descriptionCard.title' | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- Description Card -->
  <div class="course-description-card__card">
    <div class="course-description-card__content">
      <div class="course-description-card__text">
        <div class="course-description-card__editable">
          {{ course()?.courseDescription || ('app.components.courseCreator.publish.descriptionCard.placeholder' | translate) }}
        </div>
      </div>
    </div>
  </div>
</div>

